export enum VariableTypeEnum {
    ANALYSIS = 1801,
    ENVIRONMENT_CONDITION = 1802,
    GERMPLASM_DESCRIPTOR = 1804,
    STUDY_DETAIL = 1805,
    ENVIRONMENT_DETAIL = 1806,
    SELECTION_METHOD = 1807,
    TRAIT = 1808,
    TREATMENT_FACTOR = 1809,
    EXPERIMENTAL_DESIGN = 1810,
    ANALYSIS_SUMMARY = 1811,
    OBSERVATION_UNIT = 1812,
    GERMPLASM_PASSPORT = 1813,
    GERMPLASM_ATTRIBUTE = 1814,
    ENTRY_DETAIL = 1815,
    INVENTORY_ATTRIBUTE = 1816,
    GENOTYPE_MARKER = 1817
}
